import { Box, H3, Link, Separator, Text } from '@betterment/samba-react';
import { SambaAutoLink } from '@betterment/shared-components';
import { ThemedImage } from '@betterment/shared-components/src/components/themed-image/ThemedImage';

import transferSupportImage from '../../images/advisor-network/support.svg';
import { urlBuilder } from '../../Shared/urlBuilder';

export const TransferSupport: React.FC = () => {
  return (
    <Box css={{ bg: 'background', display: 'grid', gap: 'space.200', p: 'space.300', borderRadius: 'large' }}>
      <Box css={{ display: 'flex', gap: 'space.300' }}>
        <ThemedImage
          themedAsset={{
            dark: transferSupportImage,
            light: transferSupportImage,
          }}
          alt="Transfer Support"
          css={{
            width: 'size.800',
            height: 'auto',
          }}
        />
        <Box>
          <H3 variant="title100">Free transfer support</H3>
          <Text>
            If you’re transferring $75K or more, a Betterment specialist can personally guide you through the
            process—free of charge.{' '}
            <SambaAutoLink to={urlBuilder.appAdviceInitiationCallEligible.absolute()}>
              Get transfer support
            </SambaAutoLink>
          </Text>
        </Box>
      </Box>
      <Separator />
      <Text variant="text100" color="text.weak">
        For smaller transfers, please reach out to{' '}
        <Link href="mailto:rollover@betterment.com" css={{ color: 'text.weak', textDecoration: 'underline' }}>
          rollover@betterment.com
        </Link>
        , or use our chatbot for assistance.
      </Text>
    </Box>
  );
};
